import { brandOverride } from '../clients/brandOverride';
import { pxToRem } from '../helpers/pxToRem';
import { responsiveFontSizes } from '../helpers/responsiveFontSizes';

export const typography = {
  ...brandOverride().fontFamily,
  fontSize: 16,
  htmlFontSize: 10,

  body1: {
    fontWeight: 500,
    fontSize: pxToRem(16),
    ...responsiveFontSizes({ xs: 16, sm: 16, md: 16 }),
  },

  h1: {
    fontWeight: 700,
    fontSize: pxToRem(20),
    ...responsiveFontSizes({ xs: 20, sm: 20, md: 20 }),
  },

  h2: {
    fontWeight: 700,
    fontSize: pxToRem(16),
    ...responsiveFontSizes({ xs: 16, sm: 16, md: 16 }),
  },

  button: {
    fontSize: pxToRem(14),
    ...responsiveFontSizes({ xs: 14, sm: 14, md: 14 }),
  },
};
